export const SET_LOAD_OVERLAY = 'SET_LOAD_OVERLAY';
export const SET_ALERT_NOTIFICATION = 'SET_ALERT_NOTIFICATION';
export const SET_PERSON_TYPES = 'SET_PERSON_TYPES';
export const SET_META = 'SET_META';
export const RESET_META = 'RESET_META';
export const ADD_META = 'ADD_META';
export const SET_TABLE_STATE = 'SET_TABLE_STATE';
export const SET_LAST_LOADED_TABLE = 'SET_LAST_LOADED_TABLE';
